<template>
  <v-container
    class="rounded elevation-3 bg-white h-full"
    fluid>
    <v-row>
      <v-col cols="12">
        <span class="header">Line Logs</span>
      </v-col>
    </v-row>
    <v-row
      class="mt-5"
      no-gutters>
      <v-col cols="12">
        <broadcast-logs-header
          v-model="filter"
          @on-find="find()" />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-data-table
          dense
          :headers="headers"
          :items="reports"
          hide-default-footer
          no-data-text="ไม่มีข้อมูลในช่วงเวลานี้"
          loading-text="กรุณารอสักครู่...">
          <template #[`item.createdAt`]="{ item }">
            <span>
              {{ getDateFormat(item.createdAt) }}
            </span>
          </template>
          <template #[`item.message`]="{ item }">
            <div
              v-if="item.message.type === 'text'"
              class="text-left">
              {{ item.message.text }}
            </div>
            <div
              v-else-if="item.message.type === 'image'"
              class="image-container my-2"
              @click="showPreview(item.message.originalContentUrl)">
              <img
                class="rounded"
                :src="item.message.originalContentUrl"
                alt="Image">
            </div>
            <div
              v-else
              class="text-left">
              Unknown
            </div>
          </template>
          <template #[`item.createdBy`]="{ item }">
            <span>
              {{ item.createdBy.email }}
            </span>
          </template>
        </v-data-table>
      </v-col>
      <v-col cols="12">
        <v-pagination
          v-model="page"
          :length="totalPages"
          circle
          total-visible="7" />
      </v-col>
    </v-row>
    <image-preview v-model="imagePreview" />
  </v-container>
</template>

<script>
import { mapActions } from 'vuex'
import LineProvider from '@/resources/LineProvider'
import BroadcastLogsHeader from '../components/BroadcastLogsHeader.vue'
import ImagePreview from '../components/ImagePreview.vue'

const LineService = new LineProvider()

export default {
  components: { BroadcastLogsHeader, ImagePreview },
  data () {
    return {
      page: 1,
      perPage: 20,
      totalPages: 0,
      totalReports: 0,
      headers: [
        {
          text: 'Date',
          value: 'createdAt',
          sortable: true,
          align: 'center',
          width: '150px'
        },
        {
          text: 'Receiver',
          value: 'to',
          sortable: false,
          align: 'center'
        },
        {
          text: 'Message',
          value: 'message',
          sortable: false,
          align: 'center'
        },
        {
          text: 'Sender',
          value: 'createdBy',
          sortable: false,
          align: 'center'
        }
      ],
      reports: [],
      filter: {
        dates: [
          this.$dayjs().subtract(6, 'day').format('YYYY-MM-DD'),
          this.$dayjs().format('YYYY-MM-DD')
        ],
        searchInput: ''
      },
      imagePreview: {
        active: false,
        imgSrc: null
      }
    }
  },
  watch: {
    page () {
      this.fetchReports()
    }
  },
  created () {
    this.fetchReports()
  },
  methods: {
    ...mapActions({
      setSnackbar: 'Components/setSnackbar',
      setModal: 'Components/setModal',
      setLoading: 'Components/setLoading'
    }),
    async fetchReports (isClear = false) {
      try {
        this.setLoading({ active: true })

        if (isClear) {
          this.page = 1
        }

        const { data } = await LineService.getLineMessages({
          page: this.page,
          limit: this.perPage,
          startDate: this.$dayjs(this.filter.dates[0]).add(7, 'h').utc().toISOString(),
          endDate: this.$dayjs(this.filter.dates[1]).add(31, 'h').utc().toISOString(),
          search: this.filter.searchInput
        })

        this.totalPages = data.pages
        this.totalReports = data.total
        this.reports = []

        for (const result of data.results) {
          for (const message of result.message) {
            this.reports.push({
              to: result?.member?.tel || '-',
              message,
              createdAt: result.createdAt,
              createdBy: result.createdBy
            })
          }
        }
      } catch (error) {
        this.setSnackbar({
          value: true,
          message: `[GET-REPORT-ERROR]: ${error.message}`,
          type: 'error'
        })
      } finally {
        this.setLoading({ active: false })
      }
    },
    getDateFormat (date) {
      return this.$dayjs(date).format('DD/MM/YYYY HH:mm')
    },
    find () {
      this.fetchReports(true)
    },
    showPreview (imgSrc) {
      this.imagePreview = {
        active: true,
        imgSrc
      }
    }
  }
}
</script>

<style scoped>
.w-full {
  width: 100%;
}
.h-full {
  height: 100%;
}
.header {
  font-size: 1.5rem;
  font-weight: bold;
}
.bg-white {
  background-color: white !important;
}
.image-container {
  width: 75px;
  height: 75px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-content: center;
}
.image-container img {
  object-fit: cover;
}
</style>
